import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import Help_hints from "./help_hints";
import "./css/wepcg_bar.css"

class PriceProtectionDisputeBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>Price Protection Dispute</strong></h1>
            <p>
                This dispute type is used for partial or missed price protection payments. Prior to submitting dispute please check EMEA claim status report, type of report “Price Protection”. As well please take into consideration following price protection T&Cs.
            </p>
            <Help_hints />
        </div>
    }
}

export default PriceProtectionDisputeBar;